"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampDTO = exports.TrailerDTO = exports.MineDTO = exports.MappingCenterDTO = exports.DormitoryDTO = exports.VanDTO = exports.MappingCenterOrNullDTO = exports.DormitoryOrNullDTO = exports.TrailerOrNullDTO = exports.MineOrNullDTO = exports.VanOrNullDTO = exports.StandTypeDTO = exports.StandDTO = void 0;
const class_validator_1 = require("class-validator");
const Resources_1 = require("./Resources");
let StandDTO = (() => {
    class StandDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Resources_1.StandTypes),
        __metadata("design:type", String)
    ], StandDTO.prototype, "standType", void 0);
    return StandDTO;
})();
exports.StandDTO = StandDTO;
let StandTypeDTO = (() => {
    class StandTypeDTO {
    }
    __decorate([
        class_validator_1.IsEnum(Resources_1.StandTypes),
        __metadata("design:type", String)
    ], StandTypeDTO.prototype, "standType", void 0);
    return StandTypeDTO;
})();
exports.StandTypeDTO = StandTypeDTO;
class VanOrNullDTO {
}
exports.VanOrNullDTO = VanOrNullDTO;
class MineOrNullDTO {
}
exports.MineOrNullDTO = MineOrNullDTO;
class TrailerOrNullDTO {
}
exports.TrailerOrNullDTO = TrailerOrNullDTO;
class DormitoryOrNullDTO {
}
exports.DormitoryOrNullDTO = DormitoryOrNullDTO;
class MappingCenterOrNullDTO {
}
exports.MappingCenterOrNullDTO = MappingCenterOrNullDTO;
class VanDTO extends StandDTO {
}
exports.VanDTO = VanDTO;
class DormitoryDTO extends StandDTO {
}
exports.DormitoryDTO = DormitoryDTO;
class MappingCenterDTO extends StandDTO {
}
exports.MappingCenterDTO = MappingCenterDTO;
class MineDTO extends StandDTO {
}
exports.MineDTO = MineDTO;
class TrailerDTO extends StandDTO {
}
exports.TrailerDTO = TrailerDTO;
class CampDTO {
}
exports.CampDTO = CampDTO;
//# sourceMappingURL=Camp.js.map